import { getStorageValue } from "../service/shared.service";

const CurrencyFormatter = ({ amount }: any) => {
  const currency = getStorageValue('partnerData') && getStorageValue('partnerData')['country_currency_info'] ? getStorageValue('partnerData')['country_currency_info']['currency'] : {}; // useSelector((state: any) => state?.APIData?.partnerData.country_currency_info?.currency);
  const formattedAmount = formatCurrencyUSA(amount, currency);

  return <span>{formattedAmount}</span>;
};

export const formatCurrencyUSA = (amount: any, currency?: any) => {
  currency = getStorageValue('partnerData') && getStorageValue('partnerData')['country_currency_info'] ? getStorageValue('partnerData')['country_currency_info']['currency'] : {};
  const formattedCurrency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency && currency[0]?.currency_code ? currency[0]?.currency_code : "USD", 
  }).format(amount);

  return formattedCurrency;
};

export default CurrencyFormatter;
